/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Regenerate_ResponseInputs */



/**
* | output |
* | --- |
* | "Regenerate response" |
*
* @param {Chat_Regenerate_ResponseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_regenerate_response = /** @type {((inputs?: Chat_Regenerate_ResponseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Regenerate_ResponseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Antwort neu generieren")
	return /** @type {LocalizedString} */ ("Regenerate response")
});